import React from "react";
import { Facebook } from "lucide-react";

export default function ShareButton({ url, variant = "icon", testId = "share-btn" }) {
  const share = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const full = url.startsWith("http") ? url : window.location.origin + url;
    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(full)}`,
      "fb-share",
      "width=626,height=436,noopener"
    );
  };

  if (variant === "button") {
    return (
      <button
        onClick={share}
        className="inline-flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-semibold text-[#1877F2] bg-[#1877F2]/10 border border-[#1877F2]/25 hover:bg-[#1877F2]/20 transition-colors"
        title="Share on Facebook"
        data-testid={testId}
      >
        <Facebook size={15} /> Share
      </button>
    );
  }

  return (
    <button
      onClick={share}
      className="w-8 h-8 rounded-full bg-white/95 border border-white/10 shadow-sm flex items-center justify-center text-[#1877F2] hover:bg-[#1877F2] hover:text-white transition-colors shrink-0"
      title="Share on Facebook"
      data-testid={testId}
    >
      <Facebook size={14} />
    </button>
  );
}
